import { SvgIcon, SvgIconProps } from '@mui/material';

function EnergySVG(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M4 5V19H21" stroke="#0173C8" />
      <line x1="7.5" y1="16.5" x2="7.5" y2="17.5" stroke="#0173C8" strokeLinecap="round" />
      <line x1="11.5" y1="9.5" x2="11.5" y2="15.5" stroke="#0173C8" strokeLinecap="round" />
      <line x1="13.5" y1="15.5" x2="13.5" y2="17.5" stroke="#0173C8" strokeLinecap="round" />
      <line x1="17.5" y1="6.5" x2="17.5" y2="17.5" stroke="#0173C8" strokeLinecap="round" />
      <line x1="7.5" y1="6.5" x2="7.5" y2="14.5" stroke="#0173C8" strokeLinecap="round" />
    </SvgIcon>
  );
}

export default EnergySVG;
